export default [
    {
      header: 'Documentation',
      icon: 'DownloadIcon',
      route: 'documents-telecharger',
      title: 'Documentation'
    },
  ]
  